import { memo, useEffect, useState, useContext, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import './css/questions.css'

import { AppContext } from "../../Context";
import Popups from "../../components/Popups";
import Popup from "../../components/Pop";
import { Input, MultiSelect, ImageUpload, UploadForm, ClassesDropdown, SelectBox } from "../../components/Form";
import { Config } from '../../inc/Config'
import Fetch, { Loader, GET, FetchAsync, SecoundsToTime, DateToText } from "../../inc/Fetch";

export default function EditStudent({ setOpen, Open, onSave }) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { userData, successData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [open, setopen] = successData;

    const [loading, setloading] = useState(true);
    const [loader, setloader] = useState(false);
    const [data, setdata] = useState({});
    const [values, setvalues] = useState({});
    const [tab, settab] = useState(1);

    async function loadData() {
        let r = await GET(`user/student?_id=${Open || ""}`);

        setvalues(r?.user);
        setdata(r?.history);
        setloading(false);
    }

    async function submit(e) {
        e.preventDefault();

        setloader(true);
        let res = await FetchAsync(`/user/update`, values);
        if (res?.error) {
            setopen({
                short:t("error",  { returnObjects: true })[res?.error],
                error:true
            });
        } else {
            onSave(true);
            setOpen(false);
        }

        setloader(false);

    }

    useEffect(() => {
        loadData();
    }, [])
    

    if (loading) {
        return <Loader />
    }

    return (
        <>
        {loader && <Loader />}

        <Popups setOpen={setOpen} className="studentsPop" style={{maxWidth:500}} index={17}>
          
           <h1>{t("header_user_menu_1")}</h1>

            <nav className='tabs'>
                <a onClick={() => settab(1)} className={tab == 1 ? "ck" : "none"}>{t("info")}</a>
                <a onClick={() => settab(2)} className={tab == 2 ? "ck" : "none"}>{t("stats")}</a>
            </nav>

            {tab == 1 && 
            <div className='popupBody' style={{padding:15}}>
                <div className='newGameInfoBox' style={{marginTop:5}}>

                    <div className='studentImg'>
                    
                        <UploadForm 
                            style={{maxWidth:"unset"}}
                            onChange={(e) => setvalues(p => ({ ...p, img: e }))}
                            value={values?.img}
                        />

                    </div>

                    
                    <Input 
                        validate={true}
                        title={t("name")}
                        onChange={(e) => setvalues(p => ({ ...p, name: e }))}
                        value={values?.name}

                    />

                    <ClassesDropdown
                        click={true}
                        validate={true}
                        onChange={(e) => setvalues(p => ({ ...p, classes: e }))}
                        value={values?.classes}
                    />
                    

                    <Input 
                        validate={true}
                        title={t("login_username")}
                        disabled={true}
                        placeholder={" "}
                        onChange={(e) => setvalues(p => ({ ...p, user: e }))}
                        value={values?.user}
                    />

                    <Input 
                        // validate={true}
                        title={t("id")}
                        onChange={(e) => setvalues(p => ({ ...p, zehot: e }))}
                        value={values?.zehot}
                    />

                    
                    <button className='btn' onClick={submit} style={{width:'90%', padding:10}}>{t("user_update")}</button>
                </div>
            </div>
            }

            {tab == 2 && 
            <div className='popupBody' style={{padding:15}}>
                <div className='newGameInfoBox' style={{marginTop:5}}>

                    <table className='table'>
                        <thead>
                            <tr>
                                <td className='side'>{t("name")}</td>
                                <td>{t("tasks_send_timer")}</td>
                                <td>{t("tasks_score")}</td>
                                <td style={{width:90}}>{t("date")}</td>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.map((v, k) => {
                                console.log(v);
                                
                                return (
                                    <tr key={k}>
                                        <td className='side'>{v?.task?.title || v?.game?.name}</td>
                                        <td>{v?.timer ? <SecoundsToTime time={v?.timer}/> : "--"}</td>
                                        <td><span className='tag'>{v?.score}</span></td>
                                        <td><DateToText time={v?.date}/></td>
                                    </tr>

                                );
                            })}
                        </tbody>
                    </table>

                    {!data?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}
                </div>
            </div>
            }
            

        </Popups>
        </>
        
    );
}